"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicOrdersClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const OrderExceptions_1 = require("./OrderExceptions");
const FULFILLMENT_ORDER_BASE_URL = process.env.FULFILLMENT_ORDER_BASE_URL;
/**
 * This client should be used when there is no authentication present.
 * Otherwise, use `FulfillmentOrderClient`.
 */
class PublicOrdersClient extends base_client_1.ApiClient {
    constructor(baseURL = `${FULFILLMENT_ORDER_BASE_URL}/`) {
        super({ baseURL });
    }
    async getOrder(orderTrackingId) {
        try {
            return await this.get(`/public/v1/public/order/${orderTrackingId}`);
        }
        catch (error) {
            throw (0, base_client_1.mapError)(error, [OrderExceptions_1.OrderExceptions.NOT_FOUND, OrderExceptions_1.OrderExceptions.INVALID_ORDER_TRACKING_ID]);
        }
    }
}
exports.PublicOrdersClient = PublicOrdersClient;
//# sourceMappingURL=PublicOrdersClient.js.map